import MapButton from './component';

export default MapButton;
